import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateStructure, useEstimateTableSettings } from "@tools";
import { TaskUnitPriceCell, TaskUnitsCell } from "./components";
import { TaskEstimatePlaceholdersCell } from "../TaskEstimatePlaceholdersCell";

export const TaskMaterialCell = observer(({
  element,
  expanded,
}) => {
  const structure = useEstimateStructure();
  const { showCombinedHours } = useEstimateTableSettings();
  
  const { estimateValueLevel } = structure;
  const { lvl, hasMaterialChildren, hasChildren, hasMaterialPrice } = element;
  
  // const displayCellContent = !opened || !hasChildren; || hasMaterialPrice || lvl > estimateValueLevel;
  const displayCellContent = !hasMaterialChildren && lvl <= estimateValueLevel && (!expanded || hasMaterialPrice || !hasChildren);
  
  return <>
    <TaskEstimatePlaceholdersCell cutLastWorkTypes={2} />
    {
      !showCombinedHours &&
      <>
        <TaskUnitPriceCell
          element={element}
          displayCellContent={displayCellContent}
        />
        <TaskUnitsCell
          element={element}
          displayCellContent={displayCellContent}
        />
      </>
    }
  </>
})

TaskMaterialCell.propTypes = {
  element: object.isRequired,
  // actualDepthLevel: number,
  expanded: bool,
};
